import { createInstance } from '@module-federation/runtime';

const mf = createInstance({
  name: 'clm-portal-frontend-view',
  remotes: [],
});

export async function loadRemoteWebComponent(name: string, url: string, componentName: string) {
  mf.registerRemotes([{ name, entry: url, type: 'module' }]);
  await mf.loadRemote(`${name}/${componentName}`);
}
